/**
 * Estados full-page padronizados. Substitui as 4 cópias de spinner/erro que
 * existiam em RequireAuth, RequireProjectAccess, ProjectProvider e
 * InitiativeProvider, e elimina o "flash" entre eles (o React mantém o
 * mesmo componente montado, só troca props/children).
 */

export function FullPageLoader({ label }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background gap-3">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      {label && <p className="text-sm text-muted-foreground">{label}</p>}
    </div>
  )
}

export function FullPageMessage({ title, message, action }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>
      {message && (
        <p className="mt-2 max-w-md text-sm text-muted-foreground whitespace-pre-line">{message}</p>
      )}
      {action}
    </div>
  )
}
